import { render } from "./PhotoDetail.vue?vue&type=template&id=1e198b70"
import script from "./PhotoDetail.vue?vue&type=script&lang=js"
export * from "./PhotoDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__